/**
 * <mb-shipping-calculator>: frete por CEP (portado de components/shipping.js).
 * Máscara 00000-000 no campo, mesmas mensagens de erro e a mesma lista de métodos do tema anterior.
 *
 * Como o /frete_produto da Vnda, cota o PRODUTO da página — a variante e a quantidade escolhidas, ou as
 * peças marcadas do kit — e não o carrinho: fetchProductShippingRates (shipping-rates.js) monta um carrinho
 * avulso que não toca no do cliente. A Shopify não devolve o endereço do CEP, então a linha de rua/cidade
 * do tema anterior não é exibida.
 */
const { formatMoney } = window.MB;
const { fetchProductShippingRates, maskZip } = window.MB;

class MbShippingCalculator extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form[name="shipping-form"]');
    if (!this.form) return;
    this.input = this.form.querySelector('.input');
    this.button = this.form.querySelector('.action');
    this.error = this.querySelector('[data-shipping-error]');
    this.list = this.querySelector('[data-list-shipping]');

    maskZip(this.input);

    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.calculate();
    });
  }

  get strings() {
    return (window.theme && window.theme.strings) || {};
  }

  /**
   * O que cotar: no kit, as peças marcadas e disponíveis (cada uma na quantidade do kit); no produto, a
   * variante e a quantidade do formulário de compra (o campo de quantidade se liga a ele por `form=`).
   */
  lines() {
    const kit = this.closest('mb-kit-form');
    if (kit && typeof kit.buyableItems === 'function') {
      const quantity = kit.quantity();
      return kit.buyableItems().map((item) => ({ id: item.dataset.variantId, quantity }));
    }

    const host = this.closest('[data-form-id]');
    const form = host && document.getElementById(host.dataset.formId);
    if (!form) return [];
    const data = new FormData(form);
    const id = data.get('id');
    const quantity = Math.max(1, Number(data.get('quantity')) || 1);
    return id ? [{ id, quantity }] : [];
  }

  showError(message) {
    if (!this.error) return;
    this.error.textContent = message || '';
    this.error.classList.toggle('-visible', Boolean(message));
  }

  async calculate() {
    const zip = this.input.value.replace(/\D/g, '');
    if (zip.length !== 8) {
      this.showError(this.strings.shippingInvalidZip);
      return;
    }
    const lines = this.lines();
    if (!lines.length) {
      this.list.innerHTML = '';
      this.showError(this.strings.shippingNoItems);
      return;
    }
    if (this.button.classList.contains('-sending')) return;

    this.showError('');
    this.button.classList.add('-sending');
    try {
      this.render(await fetchProductShippingRates(lines, zip));
    } catch (error) {
      this.list.innerHTML = '';
      this.showError(this.strings.shippingError);
    }
    this.button.classList.remove('-sending');
  }

  render(rates) {
    if (!rates.length) {
      this.list.innerHTML = '';
      this.showError(this.strings.shippingEmpty);
      return;
    }
    const items = rates
      .map((rate) => {
        const price = rate.cents === 0 ? this.strings.shippingFree : formatMoney(rate.cents);
        // Entrega local: o nome do tema ("Motoboy", como no checkout) no lugar do "Local Delivery" da Shopify.
        const name = rate.type === 'LOCAL' && this.dataset.localDelivery ? this.dataset.localDelivery : rate.name;
        return `
          <li class="shipping-list-item">
            <div class="method">
              <p class="type">${name}</p>
              <p class="price">${price}</p>
            </div>
            ${rate.description ? `<span class="prazo">${rate.description}</span>` : ''}
          </li>
        `;
      })
      .join('');
    this.list.innerHTML = `<ul class="shipping-list">${items}</ul>`;
  }
}

if (!customElements.get('mb-shipping-calculator')) customElements.define('mb-shipping-calculator', MbShippingCalculator);
